import P from 'prop-types';
import { Api } from '../../../../services/api';
import { useAuth } from '../../../../context/Auth/useAuth';

// eslint-disable-next-line no-unused-vars
export const DeleteUser = ({ user, updateList }) => {
  const auth = useAuth();

  const deleteUser = async () => {
    try {
      await Api.delete(`/user/delete/${user.id}`);
      updateList();
    } catch {
      return 0;
    }
  };

  return (
    <>
      {user.id == auth.token ? (
        <button
          type="button"
          className="btn btn-outline-danger"
          data-bs-toggle="tooltip"
          data-bs-placement="bottom"
          data-bs-title="Tooltip on bottom"
          disabled={true}
        >
          Deletar
        </button>
      ) : (
        <>
          <button
            type="button"
            className="btn btn-outline-danger"
            data-bs-toggle="modal"
            data-bs-target={`#modalDeleteUser${user.id}`}
          >
            Deletar
          </button>

          <div
            className="modal fade"
            id={`modalDeleteUser${user.id}`}
            tabIndex="-1"
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
          >
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header">
                  <h1 className="modal-title fs-5" id="exampleModalLabel">
                    Deseja excluir este usuário?
                  </h1>
                  <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div className="modal-body">
                  <div className="mt-3">
                    <label htmlFor="exampleFormControlInput1" className="form-label">
                      Nome
                    </label>
                    <input
                      name="nome"
                      type="text"
                      className="form-control"
                      id="exampleFormControlInput1"
                      placeholder="Nome completo do usuário"
                      value={user.nome}
                      disabled={true}
                    />
                  </div>

                  <div className="mt-3">
                    <label htmlFor="exampleFormControlInput1" className="form-label" disabled={true}>
                      Usuário
                    </label>
                    <input
                      name="nick"
                      type="text"
                      className="form-control"
                      id="exampleFormControlInput1"
                      placeholder="Usuário"
                      value={user.nick}
                      disabled={true}
                    />
                  </div>
                </div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">
                    Cancelar
                  </button>
                  <button type="button" className="btn btn-outline-danger" data-bs-dismiss="modal" onClick={deleteUser}>
                    Excluir
                  </button>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

DeleteUser.propTypes = {
  user: P.object,
  updateList: P.func,
};
